/* Base theme script. Progressive enhancement only: every feature below has a working no-script
   fallback (forms post to Shopify, the cart icon links to /cart, details/summary open natively).
   Modules: cart (drawer + section rendering), header (sticky show-on-scroll-up, menu drawer),
   product (variants, image swatches, gallery, zoom, sticky buy, recently viewed),
   collection (filters auto-submit, load more). No dependencies. Motion is feedback only and
   every transition respects prefers-reduced-motion through the stylesheet. */
(function () {
  'use strict';
  var T = window.theme || {};
  /* Every word this script shows comes from window.storeStrings, which layout/theme.liquid renders
     from the locale files, so a store in another language needs no change here. */
  var S = window.storeStrings || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---- money -------------------------------------------------------------------------- */
  function money(cents) {
    var format = T.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var decimals = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var thousands = ',';
    var decimal = '.';
    if (key.indexOf('comma_separator') > -1) { thousands = '.'; decimal = ','; }
    if (key.indexOf('space_separator') > -1) { thousands = ' '; decimal = ','; }
    if (key.indexOf('apostrophe_separator') > -1) { thousands = "'"; decimal = '.'; }
    var parts = n.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join(decimal));
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* The same markup as snippets/price.liquid, for the variant a shopper picks: the struck former price, the price in
     the sale colour and, on an element with data-price-off, the percentage next to it ("−40%" as on fellnora.com,
     rounded as kortingsmix.mjs rounds). The hidden label for the struck price comes from data-was-label. */
  function priceHtml(el, was, now) {
    if (!(was > now)) return '<span class="price__now">' + money(now) + '</span>';
    var html = '<s class="price__was"><span class="visually-hidden">' + escHtml(el.getAttribute('data-was-label') || '') + ' </span>' + money(was) + '</s> <span class="price__now is-sale">' + money(now) + '</span>';
    if (el.hasAttribute('data-price-off')) {
      var pct = Math.round((was - now) * 100 / was);
      if (pct > 0) html += ' <span class="price-off">−' + pct + '%</span>';
    }
    return html;
  }

  /* ---- thema 2: seizoenseffect (03-10-2026) -------------------------------------------------------------------- */
  /* Owner: "bij drukken van atc moet er wat gebeuren op de shop, herfst blaadjes? Wintervlokken?", "lang 2 tot 2,5s" and
     "niet zo zwaar maken dat de store niet langzaam gaat worden ... op basis van datum automatisch". A short shower of the
     season's particles from the button the shopper pressed, only on a real event: a product in the cart, free shipping
     reached. The moment comes from the date and her country (snippets/season.liquid via window.theme.fx: autumn leaves,
     snow, Christmas, New Year, Valentine, blossom, summer sparkle; Christmas in Australia without snow; and the moments
     of the calendar: bats and pumpkins at Halloween, tags in the week of Black Friday, bolts on Cyber Monday, tulips,
     flowers, eggs, gifts and stars). Nothing loads or
     runs until then: no library, no images, a few inline shapes animated on the compositor (transform and opacity) in one
     layer that is removed when done. Every time long (2 to 2.5 s); fewer particles on a weak device; none with reduced
     motion, data saving or a hidden page. */
  var FX = (function () {
    var cfg = T.fx;
    if (!cfg || !document.body || !document.body.animate) return { cheer: function () {} };
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var weak = (navigator.deviceMemory && navigator.deviceMemory <= 2) || (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2);
    var SHAPE = {
      leaf: '<path d="M12 2C7.5 5.5 5 9.5 5 13.2 5 17.4 8.1 20.6 12 22c3.9-1.4 7-4.6 7-8.8C19 9.5 16.5 5.5 12 2Z" fill="currentColor"/><path d="M12 6.5V21" stroke="#000" stroke-opacity=".18" stroke-width="1.2" fill="none"/>',
      maple: '<path d="M12 1.8l1.9 4.1 3.6-1.2-1 3.8 4.1 1.6-3.6 2.2 1.4 3.6-4-.8-.9 4.1h-3l-.9-4.1-4 .8 1.4-3.6-3.6-2.2 4.1-1.6-1-3.8 3.6 1.2Z" fill="currentColor"/>',
      flake: '<g stroke="currentColor" stroke-width="1.7" stroke-linecap="round" fill="none"><path d="M12 2.5v19M3.8 7.25l16.4 9.5M3.8 16.75l16.4-9.5"/><path d="M9.8 4.3 12 6.2l2.2-1.9M9.8 19.7 12 17.8l2.2 1.9M4.6 10.4l2.9.6.9-2.8M19.4 13.6l-2.9-.6-.9 2.8M4.6 13.6l2.9-.6.9 2.8M19.4 10.4l-2.9.6-.9-2.8"/></g>',
      star: '<path d="M12 2.5l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.4 6.1 20.5l1.2-6.5-4.8-4.6 6.6-.9Z" fill="currentColor"/>',
      spark: '<path d="M12 2l2.1 7.9L22 12l-7.9 2.1L12 22l-2.1-7.9L2 12l7.9-2.1Z" fill="currentColor"/>',
      heart: '<path d="M12 21s-7.5-4.6-9.6-9.4C.9 7.9 3.4 4 7.2 4c2.1 0 3.6 1.1 4.8 2.8C13.2 5.1 14.7 4 16.8 4c3.8 0 6.3 3.9 4.8 7.6C19.5 16.4 12 21 12 21Z" fill="currentColor"/>',
      petal: '<ellipse cx="12" cy="12" rx="5.5" ry="9.5" fill="currentColor"/>',
      confetti: '<rect x="8" y="3" width="8" height="18" rx="1.5" fill="currentColor"/>',
      /* The moments of the calendar (snippets/season.liquid, 03-10-2026). */
      bat: '<path d="M12 8c.5-.9 1-1.4 1-1.4l.4 1.5c1.6-1.1 3.8-1.6 5.9-1.2 1.6.3 3 1.1 4.2 2.2-1.5-.2-2.8.4-3.5 1.5-.9-.7-2.2-.8-3.1-.2-.7.5-1 1.3-.8 2.2-1.1-.6-2.6-.4-3.4.6L12 15.5l-.6-1.3c-.8-1-2.3-1.2-3.4-.6.2-.9-.1-1.7-.8-2.2-.9-.6-2.2-.5-3.1.2-.7-1.1-2-1.7-3.5-1.5 1.2-1.1 2.6-1.9 4.2-2.2 2.1-.4 4.3.1 5.9 1.2l.4-1.5s.5.5 1 1.4Z" fill="currentColor"/>',
      pumpkin: '<path d="M12 7.2c-1.2-.9-2.8-1.2-4.3-.8C4.6 7.2 3 10 3 13.4 3 17.3 5.7 20 9 20c1.1 0 2.1-.3 3-.8.9.5 1.9.8 3 .8 3.3 0 6-2.7 6-6.6 0-3.4-1.6-6.2-4.7-7-1.5-.4-3.1-.1-4.3.8Z" fill="currentColor"/><path d="M12 7.2V4.4c0-.7.6-1.3 1.3-1.3h.9" stroke="#5E8C3A" stroke-width="1.8" stroke-linecap="round" fill="none"/>',
      tag: '<path d="M3 12.6V4.5C3 3.7 3.7 3 4.5 3h8.1c.4 0 .8.2 1.1.4l7.4 7.4c.6.6.6 1.5 0 2.1l-8.1 8.1c-.6.6-1.5.6-2.1 0l-7.5-7.4c-.3-.3-.4-.7-.4-1Z" fill="currentColor"/><circle cx="8" cy="8" r="1.7" fill="#fff" fill-opacity=".6"/>',
      bolt: '<path d="M13.5 2 4.5 13.5h6L9.5 22l9-11.5h-6Z" fill="currentColor"/>',
      gift: '<rect x="3.5" y="9.5" width="17" height="11" rx="1.2" fill="currentColor"/><rect x="2.5" y="6.5" width="19" height="3.8" rx="1" fill="currentColor"/><path d="M12 6.5v14" stroke="#fff" stroke-opacity=".55" stroke-width="1.6"/>',
      tulip: '<path d="M12 3c-1.6 1.4-2.5 3-2.6 3.8L7 4.8c-.6 3.3.2 6.4 2.4 8 .8.6 1.7.9 2.6.9s1.8-.3 2.6-.9c2.2-1.6 3-4.7 2.4-8l-2.4 2C14.5 6 13.6 4.4 12 3Z" fill="currentColor"/><path d="M12 13.7V21" stroke="#5E8C3A" stroke-width="1.6" stroke-linecap="round"/>',
      flower: '<g fill="currentColor"><circle cx="12" cy="6.6" r="3.3"/><circle cx="17.1" cy="10.3" r="3.3"/><circle cx="15.2" cy="16.3" r="3.3"/><circle cx="8.8" cy="16.3" r="3.3"/><circle cx="6.9" cy="10.3" r="3.3"/></g><circle cx="12" cy="12" r="2.6" fill="#F7D774"/>',
      egg: '<path d="M12 2.5c-3.6 0-6.5 6-6.5 11 0 4.2 2.9 8 6.5 8s6.5-3.8 6.5-8c0-5-2.9-11-6.5-11Z" fill="currentColor"/>'
    };
    var SETS = {
      autumn: { shapes: ['leaf', 'maple', 'leaf'], colors: ['#C2611F', '#D9822B', '#A63A1E', '#E3A23A', '#8C4A1F'], spin: 720, slow: 1 },
      winter: { shapes: ['flake'], colors: ['#8FB3DB', '#6F98C8', '#A9C5E6', '#5C86B8'], spin: 240, slow: 1.1 },
      christmas: { shapes: ['flake', 'star', 'flake'], colors: ['#8FB3DB', '#6F98C8', '#C9A227', '#B8322A'], spin: 300, slow: 1.08 },
      christmasSummer: { shapes: ['star', 'spark'], colors: ['#C9A227', '#E3B341', '#B8322A'], spin: 360, slow: 1 },
      newyear: { shapes: ['confetti', 'spark', 'confetti'], colors: ['#C9A227', '#1F1F1F', '#B8B8B8', '#E3B341'], spin: 900, slow: 1 },
      valentine: { shapes: ['heart'], colors: ['#C8385E', '#E06C8C', '#A61E45'], spin: 120, slow: 1.05 },
      spring: { shapes: ['petal', 'petal', 'leaf'], colors: ['#F2A7BE', '#E8839F', '#F7C9D6', '#7FAE5A'], spin: 540, slow: 1.05 },
      summer: { shapes: ['spark', 'star'], colors: ['#E3A23A', '#F0B94A', '#D9822B'], spin: 300, slow: 1 },
      /* Shapes and colours run side by side (particle i takes shape i and colour i), so a pumpkin is always orange. */
      halloween: { shapes: ['bat', 'pumpkin', 'leaf', 'bat'], colors: ['#2B2B2B', '#F08A24', '#D9822B', '#5E3A87'], spin: 300, slow: 1.05 },
      singles: { shapes: ['heart', 'confetti', 'spark'], colors: ['#E06C8C', '#C8385E', '#E3B341'], spin: 600, slow: 1 },
      blackfriday: { shapes: ['tag', 'confetti', 'spark', 'confetti'], colors: ['#1F1F1F', '#C9A227', '#E3B341', '#1F1F1F'], spin: 540, slow: 1 },
      cybermonday: { shapes: ['bolt', 'confetti', 'spark'], colors: ['#2B9FD9', '#7C4DFF', '#2B9FD9'], spin: 420, slow: 0.95 },
      boxingday: { shapes: ['gift', 'confetti', 'star'], colors: ['#C0392B', '#C9A227', '#2E6B4F'], spin: 360, slow: 1 },
      womensday: { shapes: ['tulip', 'petal', 'tulip', 'petal'], colors: ['#E8839F', '#F2A7BE', '#C8385E', '#F7C9D6'], spin: 360, slow: 1.05 },
      mothersday: { shapes: ['flower', 'heart', 'petal'], colors: ['#F2A7BE', '#C8385E', '#E8839F'], spin: 360, slow: 1.05 },
      easter: { shapes: ['egg', 'petal', 'egg', 'leaf'], colors: ['#F2D16B', '#F2A7BE', '#9EC5E8', '#7FAE5A'], spin: 300, slow: 1.05 },
      eofy: { shapes: ['tag', 'confetti', 'spark'], colors: ['#2A9D8F', '#E3B341', '#2A9D8F'], spin: 540, slow: 1 },
      usa: { shapes: ['star', 'confetti', 'star'], colors: ['#B22234', '#3C3B6E', '#B8B8B8'], spin: 360, slow: 1 }
    };
    SETS.memorial = SETS.july4 = SETS.labor = SETS.usa;
    var set = SETS[cfg.m === 'christmas' && cfg.s === 'summer' ? 'christmasSummer' : cfg.m] || SETS.autumn;
    var running = 0;
    var last = 0;
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function burst(rect, long, n) {
      var layer = $('.fx-layer');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'fx-layer';
        layer.setAttribute('aria-hidden', 'true');
        document.body.appendChild(layer);
      }
      var x0 = rect.left + rect.width / 2;
      var y0 = rect.top + rect.height / 2;
      var fallMax = Math.min(320, window.innerHeight * 0.4);
      for (var i = 0; i < n; i++) {
        var size = long ? rnd(20, 30) : rnd(14, 20);
        var p = document.createElement('span');
        p.className = 'fx-p';
        p.style.width = p.style.height = size + 'px';
        p.style.color = set.colors[i % set.colors.length];
        p.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true">' + SHAPE[set.shapes[i % set.shapes.length]] + '</svg>';
        layer.appendChild(p);
        var sx = x0 + rnd(-0.3, 0.3) * rect.width - size / 2;
        var sy = y0 - size / 2;
        var up = long ? rnd(90, 180) : rnd(50, 110);
        var spread = rnd(-1, 1) * (long ? 150 : 90);
        var fall = long ? rnd(fallMax * 0.7, fallMax) : rnd(40, 80);
        var sway = (long ? rnd(18, 34) : 10) * (Math.random() < 0.5 ? -1 : 1);
        var rot = rnd(-0.5, 0.5) * set.spin;
        var at = (function (sx, sy) {
          return function (x, y, s, r) { return 'translate(' + (sx + x).toFixed(1) + 'px,' + (sy + y).toFixed(1) + 'px) rotate(' + Math.round(r) + 'deg) scale(' + s + ')'; };
        })(sx, sy);
        var frames = long
          ? [{ transform: at(0, 0, 0.3, 0), opacity: 0 }, { transform: at(spread * 0.6, -up, 1, rot * 0.2), opacity: 1, offset: 0.2 }, { transform: at(spread * 0.75 + sway, -up * 0.45, 1, rot * 0.45), opacity: 1, offset: 0.42 }, { transform: at(spread * 0.85 - sway, fall * 0.4, 0.96, rot * 0.7), opacity: 0.95, offset: 0.68 }, { transform: at(spread + sway, fall, 0.9, rot), opacity: 0 }]
          : [{ transform: at(0, 0, 0.4, 0), opacity: 0 }, { transform: at(spread * 0.7, -up * 0.7, 1, rot * 0.5), opacity: 1, offset: 0.35 }, { transform: at(spread, fall - up * 0.4, 0.9, rot), opacity: 0 }];
        running++;
        var anim = p.animate(frames, { duration: (long ? rnd(1900, 2200) : rnd(1000, 1300)) * set.slow, delay: long ? rnd(0, 100) : 0, easing: long ? 'cubic-bezier(.25,.6,.35,1)' : 'cubic-bezier(.2,.7,.3,1)', fill: 'both' });
        anim.onfinish = anim.oncancel = (function (el) {
          return function () {
            if (el.parentNode) el.parentNode.removeChild(el);
            running -= 1;
            if (running <= 0 && layer.parentNode) layer.parentNode.removeChild(layer);
          };
        })(p);
      }
    }
    return {
      /* rect: where the shower starts. kind: 'add' or 'reward'; both long, 2 to 2.5 s (owner 03-10-2026: at the add to
         cart button the 1 s shower showed after the first add, he wants the long one every time). */
      cheer: function (rect, kind) {
        if (!rect || (mq && mq.matches) || (navigator.connection && navigator.connection.saveData) || document.hidden) return;
        var now = Date.now();
        if (kind !== 'reward' && now - last < 400) return;
        last = now;
        var long = true;
        if (kind === 'add' && navigator.vibrate) {
          try { navigator.vibrate(15); } catch (e) { /* not allowed here: no buzz */ }
        }
        var n = long ? (weak ? 12 : 22) : (weak ? 8 : 12);
        if (running > 0) n = Math.ceil(n * 0.6);
        burst(rect, long, n);
      }
    };
  })();

  /* Thema 2 (03-10-2026): a pressed checkout button says it is opening the secure checkout, so nobody presses twice
     while the checkout loads; the label comes back when the shopper returns with the back button. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || btn.disabled || !S.checkoutOpening) return;
    var label = $('span', btn);
    if (!label) return;
    btn.setAttribute('data-label', label.textContent);
    setTimeout(function () { label.textContent = S.checkoutOpening; btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-opening'); }, 0);
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    $$('button[name="checkout"][data-label]').forEach(function (b) {
      var label = $('span', b);
      if (label) label.textContent = b.getAttribute('data-label');
      b.removeAttribute('aria-busy');
      b.classList.remove('is-opening');
    });
  });

  function freeShipBar(root) { return $('.ship-bar.is-on:not(.volume-bar)', root) || $('.ship-bar.is-unlocked:not(.volume-bar)', root); }

  /* Thema 2 (03-10-2026, owner: "spaarteller in de wagen vind ik wel nice"): after a change in the cart the truck drives
     along the free-shipping bar from where it stood to where it is now (snippets/cart-offers.liquid, data-ship-pct), and
     "Du sparer i alt ..." counts up to the new amount when the savings grew (snippets/cart-savings.liquid,
     data-cart-save in cents). Nothing moves with reduced motion; the numbers are always the ones Shopify rendered. */
  function calm() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function shipPct(root) { var bar = root && $('.ship-bar[data-ship-pct]', root); return bar ? Number(bar.getAttribute('data-ship-pct')) : null; }
  function saveCents(root) { var el = root && $('[data-cart-save]', root); return el ? Number(el.getAttribute('data-cart-save')) : 0; }
  function driveShip(root, from) {
    var bar = root && $('.ship-bar[data-ship-pct]', root);
    if (!bar || from == null || calm()) return;
    var to = Number(bar.getAttribute('data-ship-pct'));
    if (to === from) return;
    var fill = $('.ship-bar__fill', bar);
    var truck = $('.ship-bar__truck', bar);
    function place(p) {
      if (fill) fill.style.width = p + '%';
      if (truck) truck.style.left = 'clamp(9px, ' + p + '%, calc(100% - 9px))';
    }
    bar.classList.add('is-still');
    place(from);
    void bar.offsetWidth;
    bar.classList.remove('is-still');
    place(to);
  }
  function countSave(root, from) {
    var el = root && $('[data-cart-save]', root);
    if (!el || calm()) return;
    var to = Number(el.getAttribute('data-cart-save'));
    if (!(to > from)) return;
    var decoder = document.createElement('textarea');
    decoder.innerHTML = el.getAttribute('data-template') || '';
    var tpl = decoder.value;
    if (tpl.indexOf('%amount%') === -1) return;
    var start = null;
    function frame(now) {
      if (start === null) start = now;
      var k = Math.min(1, (now - start) / 900);
      var v = from + (to - from) * (1 - Math.pow(1 - k, 3));
      el.textContent = tpl.replace('%amount%', money(k < 1 ? Math.round(v / 100) * 100 : to));
      if (k < 1) window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
    if (el.animate) el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.12)' }, { transform: 'scale(1)' }], { duration: 450, delay: 300, easing: 'ease-out' });
  }

  /* Thema 2 (03-10-2026, owner: "Lege wagen mag ook zeker gevuld worden"): an empty cart shows the bestsellers, fetched
     only when someone opens the empty cart (sections/cart-empty-feed.liquid), so no page renders them for nothing; the
     load placeholders stand in meanwhile. A failed fetch leaves the empty cart as it was. */
  function fillEmpty(root) {
    var box = root && $('[data-empty-fill]:not([data-filled])', root);
    if (!box || !window.fetch) return;
    box.setAttribute('data-filled', '');
    fetch(box.getAttribute('data-src'), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var feed = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-empty-feed]');
        if (feed && $('.product-card', feed)) {
          box.innerHTML = feed.innerHTML;
          box.removeAttribute('aria-busy');
        } else {
          box.hidden = true;
        }
      })
      .catch(function () { box.hidden = true; });
  }

  /* ---- cart --------------------------------------------------------------------------- */
  var Cart = {
    drawer: $('[data-drawer]'),
    lastFocus: null,
    sectionIds: function () {
      var ids = ['cart-icon-bubble'];
      if (this.drawer) ids.push('cart-drawer');
      var page = $('[data-cart-section]');
      if (page) ids.push(page.getAttribute('data-cart-section'));
      return ids;
    },
    open: function () {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.removeAttribute('aria-hidden');
      document.body.classList.add('drawer-open');
      var first = $('[data-cart-close]', this.drawer);
      if (first) first.focus();
      fillEmpty(this.drawer);
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    bump: function () {
      var count = $('#cart-icon-bubble .cart-count');
      if (!count) return;
      count.classList.remove('is-bumped');
      void count.offsetWidth;
      count.classList.add('is-bumped');
    },
    render: function (sections) {
      if (!sections) return;
      /* Thema 2: free shipping reached with this change is a moment worth a shower. The free-shipping line is is-on in
         snippets/cart-offers.liquid and is-unlocked in snippets/free-shipping-bar.liquid; the bar of the volume discount
         (volume-bar) is another moment and does not count here. */
      var hadBar = !!$('.ship-bar:not(.volume-bar)');
      var wasFree = !!freeShipBar(document);
      /* The savings counter: where the truck and the savings stood before this change. */
      /* The open drawer, else the cart page, else the closed drawer (an add opens it right after this). */
      var cartPage = $('[data-cart-section]');
      var ctx = this.drawer && (this.drawer.classList.contains('is-open') || !cartPage) ? this.drawer : cartPage;
      var shipFrom = shipPct(ctx);
      var saveFrom = saveCents(ctx);
      var parser = new DOMParser();
      Object.keys(sections).forEach(function (id) {
        var doc = parser.parseFromString(sections[id], 'text/html');
        if (id === 'cart-icon-bubble') {
          var bubble = $('#cart-icon-bubble');
          var fresh = $('#cart-icon-bubble', doc);
          if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
        } else if (id === 'cart-drawer') {
          var target = $('#CartDrawer');
          var next = $('#CartDrawer', doc);
          if (target && next) target.innerHTML = next.innerHTML;
        } else {
          var page = $('[data-cart-section="' + id + '"]');
          var nextPage = $('[data-cart-section]', doc);
          if (page && nextPage) page.innerHTML = nextPage.innerHTML;
        }
      });
      this.bump();
      driveShip(ctx, shipFrom);
      countSave(ctx, saveFrom);
      if (hadBar && !wasFree) {
        var page = $('[data-cart-section]');
        var freeBar = (this.drawer && this.drawer.classList.contains('is-open') && freeShipBar(this.drawer)) || (page && freeShipBar(page)) || freeShipBar(document);
        /* The leaves fall when the truck reaches the end of the bar. */
        if (freeBar) setTimeout(function () { FX.cheer(freeBar.getBoundingClientRect(), 'reward'); }, 850);
      }
      /* The fresh upsell rail starts at its first page: load on if it is short (upUpdate is declared further down). */
      $$('[data-up-rail]').forEach(upUpdate);
      /* The last item removed: the empty cart shows the bestsellers. */
      if (this.drawer && this.drawer.classList.contains('is-open')) fillEmpty(this.drawer);
      fillEmpty($('[data-cart-section]'));
    },
    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    },
    change: function (line, quantity) {
      var self = this;
      var key = line.getAttribute('data-key');
      var error = $('[data-line-error]', line);
      line.classList.add('is-loading');
      var body = { id: key, quantity: quantity, sections: this.sectionIds().join(','), sections_url: window.location.pathname };
      return this.request(T.routes.cart_change, body).then(function (json) {
        if (json.errors || json.status) {
          if (error) error.textContent = json.errors || json.message || json.description || S.cartErrorUpdate;
          line.classList.remove('is-loading');
          return;
        }
        return Gift.ensure().then(function (giftSections) { self.render(giftSections || json.sections); });
      }).catch(function () {
        if (error) error.textContent = S.cartErrorUpdateRetry;
        line.classList.remove('is-loading');
      });
    },
    add: function (form, from) {
      var self = this;
      var button = $('[data-add-button]', form) || $('button[type="submit"]', form);
      /* The element the shopper pressed: the shower starts there (the sticky bar and the size buttons say so). */
      from = from || Cart.from || button || form;
      Cart.from = null;
      var fromRect = from.getBoundingClientRect();
      var error = $('[data-product-error]');
      var fd = new FormData(form);
      fd.append('sections', this.sectionIds().join(','));
      fd.append('sections_url', window.location.pathname);
      if (error) error.textContent = '';
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
      return fetch(T.routes.cart_add, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) {
            if (error) error.textContent = json.description || json.message || S.cartErrorAdd;
            return;
          }
          if (button) {
            button.classList.add('is-done');
            setTimeout(function () { button.classList.remove('is-done'); }, 1600);
          }
          FX.cheer(from.isConnected ? from.getBoundingClientRect() : fromRect, 'add');
          return Gift.ensure().then(function (giftSections) {
            if (self.drawer) { self.render(giftSections || json.sections); self.open(); }
            else { window.location.href = T.routes.cart_url; }
          });
        })
        .catch(function () { if (error) error.textContent = S.errorGeneric; })
        .then(function () { if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); } });
    }
  };

  /* ---- thema 2: gratis cadeau bij elke bestelling ------------------------------------------ */
  /* The gift (theme setting free_gift_product, snippets/free-gift.liquid) rides along with every order: once another
     product is in the cart, its first available variant goes in with the hidden property _gift; with no other product
     left it comes out again, and there is never more than one. An automatic Buy X get Y discount in Shopify makes it
     free. A gift variant she adds herself (without _gift) is an ordinary purchase and is left alone. Each step returns
     the fresh sections when it changed the cart, so the drawer renders once, with the gift already in it. */
  var Gift = {
    on: !!(T.gift && T.gift.variant),
    ensure: function (again) {
      if (!Gift.on) return Promise.resolve(null);
      return fetch(T.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var gifts = items.filter(function (i) { return i.properties && i.properties._gift; });
          /* A gift line of another variant (the gift setting changed) goes first; then the right gift follows. */
          var stale = gifts.filter(function (i) { return i.variant_id !== T.gift.variant; })[0];
          if (stale && !again) {
            return Cart.request(T.routes.cart_change, { id: stale.key, quantity: 0 }).then(function () { return Gift.ensure(true); }).then(function (s) { return { sections: s }; });
          }
          gifts = gifts.filter(function (i) { return i.variant_id === T.gift.variant; });
          var paid = items.some(function (i) {
            return !(i.properties && i.properties._gift) && i.product_id !== T.gift.product && i.product_id !== T.gift.skip;
          });
          var body = { sections: Cart.sectionIds().join(','), sections_url: window.location.pathname };
          if (paid && !gifts.length) {
            body.items = [{ id: T.gift.variant, quantity: 1, properties: { _gift: '1' } }];
            return Cart.request(T.routes.cart_add, body);
          }
          /* One gift line of one: a second line or a higher quantity goes back; without a product the gift goes. */
          var fix = paid ? (gifts[0].quantity > 1 ? gifts[0] : gifts[1]) : gifts[0];
          if (!fix) return null;
          body.id = fix.key;
          body.quantity = paid && fix === gifts[0] ? 1 : 0;
          return Cart.request(T.routes.cart_change, body);
        })
        .then(function (json) { return json && json.sections ? json.sections : null; })
        .catch(function () { return null; });
    }
  };
  /* A cart that was filled before (another page, another visit) gets its gift on the first page view. */
  if (Gift.on && T.gift.count > 0) Gift.ensure().then(function (giftSections) { if (giftSections) Cart.render(giftSections); });
  /* The gift block on the product page (snippets/free-gift.liquid) unwraps once, when most of it is in view; then it stays
     still (WCAG 2.2.2: motion that starts by itself stops within five seconds). */
  (function () {
    var wrapped = $$('.fgift.is-wrapped');
    if (!wrapped.length) return;
    if (!('IntersectionObserver' in window)) { wrapped.forEach(function (g) { g.classList.add('is-open'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-open'); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    wrapped.forEach(function (g) { io.observe(g); });
    /* Safety net: should the observer never report (an old browser, a quirk), the gift still opens once it is on screen,
       on scroll or after four seconds, so it can never stay wrapped. */
    function onScreen() {
      wrapped.forEach(function (g) {
        if (g.classList.contains('is-open')) return;
        var r = g.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { g.classList.add('is-open'); io.unobserve(g); }
      });
    }
    window.addEventListener('scroll', onScreen, { passive: true });
    setTimeout(onScreen, 4000);
  })();

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && Cart.drawer) { e.preventDefault(); Cart.open(); return; }
    if (e.target.closest('[data-cart-close]') || (Cart.drawer && e.target === $('[data-drawer-backdrop]', Cart.drawer))) { e.preventDefault(); Cart.close(); return; }
    var qty = e.target.closest('[data-qty-change]');
    if (qty) {
      e.preventDefault();
      var line = qty.closest('[data-line]');
      var input = $('[data-qty-input]', line);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qty.getAttribute('data-qty-change'), 10));
      input.value = next;
      Cart.change(line, next);
      return;
    }
    var remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); Cart.change(remove.closest('[data-line]'), 0); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) Cart.change(input.closest('[data-line]'), Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Cart.drawer && Cart.drawer.classList.contains('is-open')) Cart.close();
      $$('details[open].menu, details[open].search, details[open].facets, details[open].card-add__pick').forEach(function (d) { d.removeAttribute('open'); });
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    /* A size panel adds only a chosen size: without one, the sizes ask for it. */
    var sizes = $$('[data-up-size]', form);
    if (sizes.length) {
      if (!$('[data-up-size][aria-pressed="true"]', form)) {
        sizes.forEach(function (b) { b.classList.remove('is-asking'); void b.offsetWidth; b.classList.add('is-asking'); });
        return;
      }
      var openPick = $('details[open]', form);
      if (openPick) openPick.removeAttribute('open');
    }
    Cart.add(form, e.submitter);
  });

  /* ---- thema 2: verzendbescherming en de rij "Tilføj og spar mere" in de winkelwagen --------- */
  /* The protection switch adds or removes its one-variant product and re-renders the cart; it is never on by default
     (snippets/cart-protection.liquid). A size button in the rail writes its variant into the card's form and submits
     it, so the add goes through Cart.add like every other add. */
  document.addEventListener('change', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-protection-toggle]');
    if (!toggle) return;
    toggle.disabled = true;
    var sections = Cart.sectionIds().join(',');
    var request = toggle.checked
      ? Cart.request(T.routes.cart_add, { items: [{ id: Number(toggle.getAttribute('data-variant-id')), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
      : Cart.request(T.routes.cart_change, { id: toggle.getAttribute('data-line-key'), quantity: 0, sections: sections, sections_url: window.location.pathname });
    request.then(function (json) {
      if (json && json.sections) Cart.render(json.sections);
      else window.location.reload();
    }).catch(function () {
      toggle.checked = !toggle.checked;
      toggle.disabled = false;
    });
  });
  /* Thema 2 (03-10-2026, owner: "als een klant een upsell wilt toevoegen dan is het nog onduidelijk via waar ze dat
     product moeten toevoegen"): in a size panel (cart rail, product cards) a tap on a size chooses it, and the black
     "+ Tilføj" underneath puts that variant in the cart; it stays grey until a size is chosen. The maatcoach chooses her
     advised size for her (mcMark below), so with an answer it is still one tap. */
  function chooseSize(form, size) {
    $$('[data-up-size]', form).forEach(function (b) {
      var on = b === size;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var id = $('input[name="id"]', form);
    if (id) id.value = size.getAttribute('data-up-size');
    var ok = $('[data-up-confirm]', form);
    if (ok) ok.classList.add('is-ready');
  }
  document.addEventListener('click', function (e) {
    var size = e.target.closest && e.target.closest('[data-up-size]');
    if (!size) return;
    e.preventDefault();
    var form = size.closest('form');
    if (form) chooseSize(form, size);
  });

  /* ---- thema 2: de rij "Tilføj til din ordre" loopt door naar rechts (30-09-2026, zonder pijlen sinds 02-10-2026) -- */
  /* Near the end of the rail the next twelve products load from the rail's collection through the Section Rendering
     API (sections/cart-upsell-feed.liquid, data-up-more holds that page); a card already in the rail stays out, and a
     page that adds nothing (all of it in the cart) moves on to the next one. No arrows (owner: "die knoppen van links naar
     rechts mogen ook weg"): the third card, cut off at the edge, shows there is more. */
  function upUpdate(rail) {
    if (rail.hasAttribute('data-up-more') && rail.scrollLeft >= rail.scrollWidth - 2 * rail.clientWidth) upLoad(rail);
  }
  function upLoad(rail) {
    var url = rail.getAttribute('data-up-more');
    if (!url || rail.hasAttribute('data-up-busy')) return;
    rail.setAttribute('data-up-busy', '');
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var page = $('[data-up-page]', new DOMParser().parseFromString(html, 'text/html'));
        var added = 0;
        if (page) $$('[data-up-id]', page).forEach(function (card) {
          if ($('[data-up-id="' + card.getAttribute('data-up-id') + '"]', rail)) return;
          rail.appendChild(card);
          added++;
        });
        var more = page ? page.getAttribute('data-up-more') : null;
        if (more) rail.setAttribute('data-up-more', more);
        else rail.removeAttribute('data-up-more');
        rail.removeAttribute('data-up-busy');
        if (!added && more) upLoad(rail);
        else upUpdate(rail);
      })
      .catch(function () {
        /* A page that fails ends the feed: the rail keeps what it has and the right arrow goes off at the end. */
        rail.removeAttribute('data-up-busy');
        rail.removeAttribute('data-up-more');
        upUpdate(rail);
      });
  }
  document.addEventListener('scroll', function (e) {
    var rail = e.target;
    if (rail && rail.matches && rail.matches('[data-up-rail]')) upUpdate(rail);
  }, true);
  $$('[data-up-rail]').forEach(upUpdate);
  /* The cart page with an empty cart fills itself right away (the drawer waits until it is opened). */
  fillEmpty($('[data-cart-section]'));

  /* ---- header: sticky show-on-scroll-up, menu drawer, search --------------------------- */
  var header = $('[data-header]');
  var menu = $('[data-menu]');
  if (header && document.body.classList.contains('has-sticky-header')) {
    var lastY = window.scrollY;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        var menuOpen = menu && menu.open;
        header.classList.toggle('is-stuck', y > 8);
        if (!menuOpen && !document.body.classList.contains('drawer-open')) {
          if (y > lastY + 6 && y > 120) header.classList.add('is-hidden');
          else if (y < lastY - 6 || y <= 120) header.classList.remove('is-hidden');
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }
  if (menu) {
    menu.addEventListener('toggle', function () {
      document.body.classList.toggle('menu-open', menu.open);
      if (menu.open && header) header.classList.remove('is-hidden');
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-close]') && menu) { menu.removeAttribute('open'); return; }
    $$('details[open].menu, details[open].search, details[open].facets, details[open].card-add__pick').forEach(function (d) {
      if (e.target === d || !d.contains(e.target)) d.removeAttribute('open');
    });
  });
  $$('details.search').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) { var i = $('input', d); if (i) i.focus(); } });
  });

  /* ---- product: variants, gallery, zoom, sticky buy, recently viewed ----------------- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('script[data-variants]', root);
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = $('form[data-product-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var button = form ? $('[data-add-button]', form) : null;
    var buttonLabel = button ? $('.btn__label', button) : null;
    var priceEl = $('[data-price]', root);
    var shipBadge = $('[data-ship-badge]', root);
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    var gallery = $('[data-gallery]', root);
    var track = gallery ? $('[data-gallery-track]', gallery) : null;
    var slides = track ? $$('[data-media-id]', track) : [];
    var thumbs = gallery ? $$('[data-thumb-for]', gallery) : [];
    var counter = gallery ? $('[data-counter]', gallery) : null;
    var lightbox = $('[data-lightbox]', root);
    var colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
    var sticky = $('[data-sticky-buy]', root);
    var strings ={ add: root.getAttribute('data-text-add') || S.addToCart, soldOut: root.getAttribute('data-text-sold-out') || S.soldOut, unavailable: root.getAttribute('data-text-unavailable') || S.unavailable };

    function setButtonText(text) { if (buttonLabel) buttonLabel.textContent = text; else if (button) button.textContent = text; }
    function selectedOptions() {
      var out = [];
      $$('[data-option-index]:checked', root).forEach(function (input) { out[parseInt(input.getAttribute('data-option-index'), 10)] = input.value; });
      return out;
    }
    function findVariant(options) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < options.length; j++) { if (variants[i].o[j] !== options[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function visibleSlides() { return slides.filter(function (s) { return !s.hidden; }); }
    function currentSlide() {
      var list = visibleSlides();
      var index = 0;
      var best = Infinity;
      list.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < best) { best = d; index = i; } });
      return { list: list, index: index, slide: list[index] };
    }
    function updateCounter() {
      if (!track) return;
      var c = currentSlide();
      if (counter) counter.textContent = (c.index + 1) + ' / ' + c.list.length;
      thumbs.forEach(function (t) {
        var active = c.slide && t.getAttribute('data-thumb-for') === c.slide.getAttribute('data-media-id');
        t.setAttribute('aria-current', active ? 'true' : 'false');
        if (active && t.scrollIntoView && !t.hidden) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }
    function scrollToMedia(id, instant) {
      var slide = slides.filter(function (s) { return s.getAttribute('data-media-id') === String(id); })[0];
      if (!slide || !track || slide.hidden) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function filterGallery(color) {
      if (isNaN(colorIndex) || !gallery) return;
      var probe = '|' + color + '|';
      slides.forEach(function (s) { var colors = s.getAttribute('data-colors') || ''; s.hidden = colors !== '' && colors.indexOf(probe) === -1; });
      thumbs.forEach(function (t) { var colors = t.getAttribute('data-colors') || ''; t.hidden = colors !== '' && colors.indexOf(probe) === -1; });
    }
    function markAvailability(options) {
      /* Only the visible buttons: the colour select and the hidden mirror radios that back it also
         carry data-option-index, and for those nextElementSibling is not a label. */
      $$('.option__values [data-option-index]', root).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-option-index'), 10);
        var test = options.slice();
        test[idx] = input.value;
        var available = variants.some(function (v) {
          if (!v.a) return false;
          for (var j = 0; j < test.length; j++) { if (test[j] !== undefined && v.o[j] !== test[j]) return false; }
          return true;
        });
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !available);
      });
      options.forEach(function (value, i) { var label = $('[data-selected-label="' + i + '"]', root); if (label) label.textContent = value; });
    }
    function thumbSrcFor(mediaId) {
      var thumb = thumbs.filter(function (t) { return t.getAttribute('data-thumb-for') === String(mediaId); })[0];
      var img = thumb && $('img', thumb);
      return img ? img.currentSrc || img.src : null;
    }
    function apply(initial) {
      var options = selectedOptions();
      var variant = findVariant(options);
      markAvailability(options);
      if (!isNaN(colorIndex)) filterGallery(options[colorIndex]);
      if (variant) {
        if (idInput) { idInput.value = variant.id; idInput.disabled = false; }
        if (priceEl) priceEl.innerHTML = priceHtml(priceEl, variant.c, variant.p);
        if (shipBadge) shipBadge.hidden = !(threshold > 0 && variant.p >= threshold);
        if (button) { button.disabled = !variant.a; setButtonText(variant.a ? strings.add : strings.soldOut); }
        if (sticky) {
          /* Thema 2: the sticky bar shows the struck price too, like viveane.com (Kortingsmix); the price paid first, so it
             never falls off on a phone (02-10-2026, as on halara.com). */
          var sp = $('[data-sticky-price]', sticky); if (sp) sp.innerHTML = variant.c > variant.p ? '<span class="sticky-buy__now is-sale">' + money(variant.p) + '</span> <s class="sticky-buy__was">' + money(variant.c) + '</s>' : money(variant.p);
          var sv = $('[data-sticky-variant]', sticky); if (sv && variant.t) sv.textContent = variant.t;
          var st = $('[data-sticky-thumb]', sticky); var src = variant.m ? thumbSrcFor(variant.m) : null; if (st && src) st.src = src;
          var sb = $('button', sticky); if (sb) sb.disabled = !variant.a;
        }
        if (variant.m) scrollToMedia(variant.m, initial);
        if (!initial && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      } else {
        if (idInput) idInput.disabled = true;
        if (button) { button.disabled = true; setButtonText(strings.unavailable); }
      }
      updateCounter();
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) apply(false); });
    if (variants.length) apply(true);

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { updateCounter(); ticking = false; });
      }, { passive: true });
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb-for]');
        if (thumb) { scrollToMedia(thumb.getAttribute('data-thumb-for')); return; }
        var nav = e.target.closest('[data-gallery-nav]');
        if (nav) {
          var c = currentSlide();
          var next = c.list[Math.min(c.list.length - 1, Math.max(0, c.index + parseInt(nav.getAttribute('data-gallery-nav'), 10)))];
          if (next) track.scrollTo({ left: next.offsetLeft, behavior: 'smooth' });
          return;
        }
        if (lightbox && (e.target.closest('[data-zoom-open]') || e.target.closest('.gallery__slide'))) {
          var slide = e.target.closest('.gallery__slide') || currentSlide().slide;
          var src = slide && slide.getAttribute('data-zoom');
          if (!src || !lightbox.showModal) return;
          var img = $('[data-lightbox-img]', lightbox);
          img.src = src;
          lightbox.showModal();
        }
      });
      if (lightbox) {
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) lightbox.close(); });
      }
      updateCounter();
    }

    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open-accordion]');
      if (!opener) return;
      var target = document.getElementById(opener.getAttribute('data-open-accordion'));
      if (target) target.open = true;
    });

    if (sticky && button && 'IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width: 989px)');
      var io = new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        var show = out && mq.matches;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-buy', show);
      }, { threshold: 0 });
      io.observe(button);
      $('button', sticky).addEventListener('click', function () {
        Cart.from = this;
        if (form.requestSubmit) form.requestSubmit(); else button.click();
      });
    }

    /* recently viewed: last 8 products in this browser only */
    var recentEl = $('script[data-recent-item]', root);
    var recentGrid = $('[data-recent-grid]');
    try {
      var item = recentEl ? JSON.parse(recentEl.textContent) : null;
      var stored = JSON.parse(window.localStorage.getItem('theme:recent') || '[]');
      var others = stored.filter(function (r) { return item && r.h !== item.h; });
      if (recentGrid && others.length) {
        recentGrid.innerHTML = others.slice(0, 6).map(function (r) {
          return '<article class="product-card"><a href="' + r.u + '"><div class="product-card__media">' + (r.i ? '<img src="' + r.i + '" width="480" height="600" loading="lazy" alt="">' : '') + '</div><h3>' + r.t.replace(/</g, '&lt;') + '</h3><p class="product-card__meta">' + r.p + '</p></a></article>';
        }).join('');
        var section = recentGrid.closest('[data-recent]');
        if (section) section.hidden = false;
      }
      if (item) window.localStorage.setItem('theme:recent', JSON.stringify([item].concat(others).slice(0, 8)));
    } catch (err) { /* storage unavailable: nothing to show */ }
  });

  /* ---- collection: filters and load more --------------------------------------------- */
  $$('form[data-facets]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') { clearTimeout(timer); timer = setTimeout(function () { form.requestSubmit ? form.requestSubmit() : form.submit(); }, 600); return; }
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
  var moreObserver = null;
  function loadMore(more) {
    var grid = $('[data-product-grid]');
    if (!grid || more.classList.contains('is-loading')) return;
    var url = more.getAttribute('href');
    more.classList.add('is-loading');
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = $('[data-product-grid]', doc);
        var nextMore = $('[data-load-more]', doc);
        if (nextGrid) Array.prototype.slice.call(nextGrid.children).forEach(function (child) { grid.appendChild(child); });
        if (nextMore) {
          more.setAttribute('href', nextMore.getAttribute('href'));
          more.classList.remove('is-loading');
          /* Observe again: if the new cards did not push the link out of reach, the observer would stay quiet. */
          if (moreObserver) { moreObserver.unobserve(more); moreObserver.observe(more); }
        } else {
          more.closest('[data-load-more-wrap]').hidden = true;
          var pag = $('[data-pagination]'); if (pag) pag.hidden = true;
          if (moreObserver) moreObserver.disconnect();
        }
        /* The page that was just added, so a refresh or the back button lands where the shopper was. */
        window.history.replaceState({}, '', url);
      })
      .catch(function () { window.location.href = url; });
  }
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-load-more]');
    if (!more) return;
    e.preventDefault();
    loadMore(more);
  });
  /* Thema 2 (02-10-2026, owner: "Infinity scroll mis ik overal net als bij Halara"): on collection and search pages the
     next page loads by itself as the shopper nears the end of the grid. The button stays as the fallback without
     IntersectionObserver, and the numbered pagination stays in the HTML for crawlers and for browsers without script. */
  var autoMore = $('[data-load-more]');
  if (autoMore && 'IntersectionObserver' in window && $('[data-product-grid]')) {
    var pagination = $('[data-pagination]'); if (pagination) pagination.hidden = true;
    moreObserver = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) loadMore(autoMore); }, { rootMargin: '0px 0px 800px 0px' });
    moreObserver.observe(autoMore);
  }

  /* Thema 2 (02-10-2026, owner: "compact 1 regel en mensen moeten weten doormiddel van pijltjes dat ze kunnen swipen naar
     links of rechts"): every rail with data-rail gets two arrows that scroll by most of its width. An arrow disappears
     at its end, and both stay hidden when everything fits (a desktop row of seven categories needs none). */
  $$('[data-rail]').forEach(function (rail) {
    var track = $('[data-rail-track]', rail);
    var prev = $('[data-rail-prev]', rail);
    var next = $('[data-rail-next]', rail);
    if (!track || !prev || !next) return;
    function update() {
      var room = track.scrollWidth - track.clientWidth;
      prev.hidden = next.hidden = room < 4;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= room - 4;
    }
    function step(dir) { track.scrollBy({ left: dir * Math.max(120, track.clientWidth * 0.8), behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    var ticking = false;
    track.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { update(); ticking = false; }); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Thema 2 (02-10-2026): colour dots on product cards (snippets/product-card.liquid). A tap shows that colour's photo,
     points the card's links at that colour and gives the quick add that colour's sizes. A quick add without a size panel
     (one choice) stays when the colour has one choice too, and steps aside when it has more, so a tap on the card picks. */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-card-dot]');
    if (!dot) return;
    e.preventDefault();
    var card = dot.closest('.product-card');
    if (!card) return;
    $$('[data-card-dot]', card).forEach(function (d) { var on = d === dot; d.classList.toggle('is-active', on); d.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var img = $('.product-card__media img', card);
    if (img && dot.getAttribute('data-img')) { img.removeAttribute('srcset'); img.src = dot.getAttribute('data-img'); }
    var url = dot.getAttribute('data-url');
    if (url) $$('a.product-card__link, a.product-card__body', card).forEach(function (a) { a.href = url; });
    var form = $('.card-add', card);
    var sizes = (dot.getAttribute('data-sizes') || '').split('|').filter(Boolean).map(function (x) { var p = x.split('~'); return { id: p[0], label: p.slice(1).join('~') }; });
    if (!form) return;
    form.hidden = !sizes.length;
    if (!sizes.length) return;
    var input = $('input[name="id"]', form); if (input) input.value = sizes[0].id;
    var box = $('.card-add__sizes', form);
    if (box) {
      box.innerHTML = '';
      sizes.forEach(function (sz) { var b = document.createElement('button'); b.type = 'button'; b.className = 'card-add__size'; b.setAttribute('data-up-size', sz.id); b.setAttribute('aria-pressed', 'false'); b.textContent = sz.label; box.appendChild(b); });
      var ready = $('[data-up-confirm]', form); if (ready) ready.classList.remove('is-ready');
      var note = $('.size-advice', form); if (note) note.parentNode.removeChild(note);
      var head = $('.card-add__head span', form); if (head) head.textContent = ' · ' + dot.getAttribute('aria-label');
    } else if (sizes.length > 1) {
      form.hidden = true;
    }
  });

  /* Thema 2 (03-10-2026, owner: "de klant al eerder een maat heeft ingevuld ... voor die product waar ze plusje heeft
     gedrukt moet eigenlijk een maat al preselected ofzo zijn en als advies gegeven worden"): when a shopper who answered
     the maatcoach opens the sizes on a card (cart rail, Fuldend looket, collections), her size for that product is marked
     and named ("Vores råd: M"). Same engine as the product page (assets/maatcoach.js, loaded only then) on the product's
     own size chart (sections/mc-data.liquid). Without answers nothing loads and the sizes stay as they are; a size that
     is sold out in that colour is not marked. One advice per product per page, until her answers change. */
  var mcPicks = {};
  var mcData = {};
  var mcSig = null;
  function mcStored() {
    try { return (window.localStorage.getItem('maatcoach-v1') || '') + '|' + (window.localStorage.getItem('fit-profile-v1') || ''); } catch (e) { return '|'; }
  }
  function mcEngine() {
    if (window.Maatcoach && window.Maatcoach.profile) return Promise.resolve(window.Maatcoach);
    if (mcEngine.loading) return mcEngine.loading;
    mcEngine.loading = new Promise(function (resolve, reject) {
      /* On a product page the maatcoach script is already on its way: wait for it instead of loading it twice. */
      var tag = $('script[src*="maatcoach.js"]');
      if (!tag) { tag = document.createElement('script'); tag.src = T.maatcoachJs; tag.defer = true; document.head.appendChild(tag); }
      tag.addEventListener('load', function () { if (window.Maatcoach && window.Maatcoach.profile) resolve(window.Maatcoach); else reject(); });
      tag.addEventListener('error', reject);
    });
    return mcEngine.loading;
  }
  function mcFetch(handle) {
    if (!mcData[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      mcData[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=mc-data', { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var node = html && new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-mc-data]');
          return node ? JSON.parse(node.textContent) : null;
        })
        .catch(function () { return null; });
    }
    return mcData[handle];
  }
  function mcMark(pick, advice) {
    var panel = $('.up__sizes, .card-add__panel', pick);
    if (!panel) return;
    var buttons = $$('[data-up-size]', pick);
    var hit = buttons.filter(function (b) { return b.textContent.trim() === advice.size; })[0];
    buttons.forEach(function (b) { b.classList.toggle('is-advised', b === hit); });
    /* Her size is chosen for her, unless she already chose one herself. */
    var form = pick.closest('form');
    if (hit && form && !$('[data-up-size][aria-pressed="true"]', form)) chooseSize(form, hit);
    var note = $('.size-advice', panel);
    if (!hit) { if (note) note.parentNode.removeChild(note); return; }
    if (!note) {
      note = document.createElement('p');
      note.className = 'size-advice';
      var head = $('.card-add__head', panel);
      if (head) head.parentNode.insertBefore(note, head.nextSibling);
      else panel.insertBefore(note, panel.firstChild);
    }
    note.textContent = String((advice.shoe ? S.mcAdviceShoe : S.mcAdvice) || '%size%').replace('%size%', advice.size);
  }
  function mcAdvise(pick) {
    var handle = pick.getAttribute('data-mc-handle');
    var sig = mcStored();
    if (sig !== mcSig) { mcPicks = {}; mcSig = sig; }
    if (sig === '|' || !T.maatcoachJs) return;
    if (mcPicks[handle] !== undefined) { if (mcPicks[handle]) mcMark(pick, mcPicks[handle]); return; }
    Promise.all([mcEngine(), mcFetch(handle)]).then(function (r) {
      var MC = r[0];
      var res = r[1] ? MC.advise(MC.analyse(r[1]), MC.profile()) : null;
      mcPicks[handle] = res && res.status === 'ok' && res.pick ? { size: String(res.pick), shoe: res.kind === 'shoe' } : null;
      if (mcPicks[handle] && pick.open) mcMark(pick, mcPicks[handle]);
    }).catch(function () { mcPicks[handle] = null; });
  }
  /* toggle does not bubble: listen while it travels down. */
  document.addEventListener('toggle', function (e) {
    var pick = e.target;
    if (pick && pick.open && pick.matches && pick.matches('details[data-mc-handle]')) mcAdvise(pick);
  }, true);
  /* Warm up on the first touch of a plus, so the advice is there by the time the sizes open. */
  document.addEventListener('pointerdown', function (e) {
    var sum = e.target.closest && e.target.closest('details[data-mc-handle] > summary');
    if (!sum || !T.maatcoachJs || mcStored() === '|') return;
    var handle = sum.parentNode.getAttribute('data-mc-handle');
    if (mcPicks[handle] === undefined) { mcEngine().catch(function () {}); mcFetch(handle); }
  }, { passive: true });
})();
